export { PostsListQuery } from './postsList.query';
